import React, { useContext } from "react";
import { Button as AntdButton, ButtonProps } from "antd";
import { useModal } from "react-modal-hook";
import { useForm, FormProvider, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Row, Col, Input } from "antd";
import FormHookModal from "../../modals/form-hook-modal";
import ProductContext from "../../../../context/product/context";
import { IoIosPricetag } from "react-icons/io";
import FormItem from "../../form-item";
import { IdAccounting } from "../../../../models/product/request";

interface IStoreForm {
  storeId: number;
  storeName: string;
  idAccounting: string; 
}

interface IFormValues {
  stores: IStoreForm[];
}

interface Props extends ButtonProps {
  passedId: number;
  quantities: any[];
}

const IdAccountingButton: React.FC<Props> = ({ passedId, quantities, ...props }) => {
  const { t } = useTranslation();
  const { actions, loading } = useContext(ProductContext);

  const [showFormModal, hideFormModal] = useModal(() => {
    const methods = useForm<IFormValues>({
      defaultValues: {
        stores: quantities.map((q) => ({
          storeId: q.store_id,
          storeName: q.store_name,
          idAccounting: q.id_accounting,
        })),
      },
    });

    const { control, handleSubmit } = methods;

    const onSubmit = async (data: IFormValues) => {
      const payload: IdAccounting = {
        storeAccountings: data.stores.map((s) => ({
          store_id: s.storeId,
          id_accounting: s.idAccounting,
        })),
      };

      await actions.setIdAccounting(passedId, payload);
      actions.getData();
      hideFormModal();
    };

    return (
      <FormHookModal
        id="id-accounting-modal"
        confirmButtonText={t("send")}
        loading={loading.includes("setIdAccounting")}
        title={t("send_id_accounting")}
        hideModal={hideFormModal}
        width="50vw"
        style={{ marginTop: "1.6rem", maxHeight: "70vh", overflowY: "auto" }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <FormProvider {...methods}>
          <form>
            {quantities.map((q, index) => (
              <Row key={q.store_id} gutter={[16, 8]} style={{ marginBottom: 8 }}>
                <Col span={8}>
                  <strong>{q.store_name}</strong>
                </Col>
                <Col span={16}>
                  <FormItem label={t("id_accounting")}>
                    <Controller
                      name={`stores.${index}.idAccounting`}
                      control={control}
                      rules={{
                        required: { value: true, message: t("field_is_required_message") },
                      }}
                      render={({ field }) => (
                        <Input
                          {...field}
                          type="text"
                          placeholder={t("enter_id_accounting")}
                          onChange={(e) => field.onChange(e.target.value)}
                        />
                      )}
                    />
                  </FormItem>
                </Col>
              </Row>
            ))}
          </form>
        </FormProvider>
      </FormHookModal>
    );
  }, [passedId, quantities, loading]);

  return (
    <AntdButton type="default" icon={<IoIosPricetag />} onClick={showFormModal} {...props}>
      {props.children || t("send_id_accounting")}
    </AntdButton>
  );
};

export default IdAccountingButton;
